import React, { FC } from 'react';
import { InlineVideoType } from '../../../models/inline-video-type';
import InlineImageVideo from '../../molecules/inline-image-video/inline-image-video';

const InlineVideo: FC<InlineVideoType> = (props: InlineVideoType) => (
  <div className="py-component-spacing-mobile lg:py-component-spacing-content mx-auto w-full md:w-10/12 lg:w-8/12">
    <InlineImageVideo {...props} />
  </div>
);

export default InlineVideo;
